import {
  IconBrandAuth0,
  IconBrowser,
  IconBuildingFactory2,
  IconBuildingWarehouse,
  IconClipboardCheck,
  IconDatabase,
  IconFileExport,
  IconKey,
  IconReceipt,
  IconReport,
  IconScale,
  IconSettings,
  IconSettingsQuestion,
  IconShoppingCart,
  IconTool,
  IconTransfer,
  IconZoomReplace,
} from "@tabler/icons-react";
import { LinksGroupProps } from "../../_base/model/_base/LinksGroupProps";

export const _sideNavData: LinksGroupProps[] = [
  //   {
  //     label: "Demo",
  //     icon: Icon2fa,
  //     initiallyOpened: false,
  //     links: [
  //       {
  //         label: "Công việc đang xử lý",
  //         link: "/system/process-task",
  //       },
  //       {
  //         label: "Quá trình duyệt",
  //         link: "/system/process-instances",
  //       },
  //       {
  //         label: "Loại tài liệu",
  //         link: "/system/document-type",
  //       },
  //       {
  //         label: "Số hồ sơ",
  //         link: "/system/file-number",
  //       },
  //     ],
  //   },
  // {
  //   label: "Khóa truy cập",
  //   icon: IconKey,
  //   initiallyOpened: false,
  //   links: [
  //     {
  //       label: "Khóa truy cập SSO",
  //       link: "/key-access/sso-get-access-key",
  //       hidden: true,
  //     },
  //   ],
  // },
  {
    label: "Danh mục dữ liệu",
    icon: IconScale,
    initiallyOpened: false,
    links: [
      {
        label: "Dữ liệu chung",
        link: "/category-data/general-data",
      },
      {
        label: "Thanh toán",
        link: "/category-data/payment",
      },
      {
        label: "Hàng hóa",
        link: "/category-data/commodities",
      },
      {
        label: "Cấu hình tag",
        link: "/category-data/tag-config",
      },
      {
        label: "Giao vận",
        link: "/category-data/transport",
      },
      // {
      //   label: "Danh mục đồng bộ",
      //   link: "/category-data/synchronous",
      // },
      // {
      //   label: "Phòng ban",
      //   link: "/organization/department",
      // },
      {
        label: "Chức vụ",
        link: "/organization/position",
      },
      {
        label: "Nhân viên",
        link: "/organization/staff",
      },
      {
        label: "Danh mục địa chỉ",
        link: "/category-data/address",
      },
      {
        label: "Danh sách chuyển đổi địa chỉ",
        link: "/category-data/address-conversion",
      },
      {
        label: "Danh sách khách hàng",
        link: "/customer-management/customer-list",
      },
      {
        label: "DS khách hàng(không công nợ)",
        link: "/customer-management/customer-list-no-debt",
      },
      {
        label: "Đối tượng công nợ",
        link: "/debtgroup/customer-debtgroup-list",
      },
      {
        label: "Danh sách nhà cung cấp",
        link: "/debtgroup/supplier-debtgroup-list",
      },
      {
        label: "Danh mục Bộ Phận",
        link: "/department/department-list",
      },
      // "Danh mục Kho" và "Danh mục vị trí Kho" đã chuyển thành tab của "Dữ liệu chung":
      // /category-data/general-data?tab=inventory và ?tab=warehouse-location-list
      // Route cũ vẫn giữ trong routes.tsx để link cũ không bị chết.
      {
        label: "Danh mục vật tư",
        link: "/category-data/supplies",
      },
      {
        label: "Thông tin tài khoản kế toán",
        link: "/category-data/accountInformation",
      },
      {
        label: "Danh sách lý do trả hàng",
        link: "/category-data/reason-for-return",
      },
      {
        label: "Danh sách voucher",
        link: "/category-data/voucher",
      },
      {
        label: "Tạo mới vourcher",
        link: "/category-data/create-vourcher",
        hidden: true,
      },
      {
        label: "Chỉnh sửa vourcher",
        link: "/category-data/edit-vourcher",
        hidden: true,
      },
      {
        label: "Xem chi tiết vourcher",
        link: "/category-data/detail-vourcher",
        hidden: true,
      },
      // {
      //   label: "Quà khuyến mãi tương đương",
      //   link: "/category-data/related-promotions",
      // },
      {
        label: "Danh sách tem sản phẩm",
        link: "/category-data/tem-product",
      },
      {
        label: "Cấu hình giao vận",
        link: "/category-data/transport-configuration",
      },
      {
        label: "Cấu hình kỹ thuật cho giao vận",
        link: "/category-data/technical-configuration",
      },
      {
        label: "Thiết lập trạng thái serial",
        link: "/category-data/serial-status-settings",
      },
      {
        label: "Thiết lập lý do YCDC",
        link: "/category-data/reason-request-transfer",
      },
      {
        label: "Thiết lập mức độ test của KT",
        link: "/category-data/test-level-categories",
      },
    ],
  },

  // {
  //   label: "Danh Mục Hóa Đơn",
  //   icon: IconFileDollar,
  //   initiallyOpened: false,
  //   links: [
  //     {
  //       label: "Hóa đơn",
  //       link: "/invoice/list",
  //     },
  //   ],
  // },

  {
    label: "Thiết lập hệ thống",
    icon: IconSettings,
    initiallyOpened: false,
    links: [
      {
        label: "Thêm mới bảng giá bán",
        link: "/config-system/list-details-price",
        hidden: true,
      },
      {
        label: "Thiết lập bảng giá bán",
        link: "/config-system/config-price",
      },
      {
        label: "Thiết lập chính sách KM",
        link: "/config-system/config-promotion-policy",
      },
      {
        label: "Thiết lập chính sách KM đa điều kiện",
        link: "/config-system/config-promotion-policy-multiple",
      },
      {
        label: "Báo cáo doanh thu CTKM dự kiến",
        link: "/config-system/profit-revenue-promotion",
      },
      {
        label: "Báo cáo CTKM",
        link: "/config-system/promotion-report",
      },
      {
        label: "Thiết lập mô tả KM",
        link: "/config-system/configsss-description-policy",
      },
      {
        label: "Thiết lập định mức nguyên vật liệu",
        link: "/config-system/config-bom",
      },
      {
        label: "Thiết lập các mức giảm giá",
        link: "/config-system/set-up-discounts",
      },
      {
        label: "Tạo mới chính sách khuyến mãi",
        link: "/config-system/create-promotion-policy",
        hidden: true,
      },
      {
        label: "Tạo mới chính sách khuyến mãi đa điều kiện",
        link: "/config-system/create-promotion-policy-multiple",
        hidden: true,
      },
      {
        label: "Chi tiết chính sách khuyến mãi",
        link: "/config-system/detail-promotion",
        hidden: true,
      },
      {
        label: "Chi tiết chính sách khuyến mãi đa điều kiện",
        link: "/config-system/detail-promotion-multiple",
        hidden: true,
      },
      {
        label: "Chỉnh sửa chính sách khuyến mãi",
        link: "/config-system/edit-promotion",
        hidden: true,
      },
      {
        label: "Chỉnh sửa chính sách khuyến mãi đa điều kiện",
        link: "/config-system/edit-promotion-multiple",
        hidden: true,
      },
      {
        label: "Thiết lập chung",
        link: "/config-system/general-settings",
        hidden: true,
      },
      {
        label: "Tạo mới định mức nguyên vật liệu",
        link: "/config-system/create-config-bom",
        hidden: true,
      },
      {
        label: "Chỉnh sửa định mức nguyên vật liệu",
        link: "/config-system/edit-config-bom",
        hidden: true,
      },
      {
        label: "Chi tiết định mức nguyên vật liệu",
        link: "/config-system/detail-config-bom",
        hidden: true,
      },
      {
        label: "Đối chiếu dữ liệu đồng bộ",
        link: "/config-system/sync-checking-exist",
      },
      {
        label: "Đối chiếu dữ liệu trên Asia và Pos",
        link: "/config-system/checking-exist",
      },
      {
        label: "Đối chiếu CTKM trên POS và WEB",
        link: "/config-system/compare-promotion-pos-web",
      },
      {
        label: "Kiểm tra dữ liệu hệ thống",
        link: "/config-system/duplicate-report",
      },
      {
        label: "Danh sách khuyến mãi theo sản phẩm",
        link: "/config-system/list-promotion-on-product",
      },
      {
        label: "Lập lịch cập nhật bảng giá",
        link: "/config-system/schedule-price-list-upload",
      },
      {
        label: "Lịch sử cập nhật bảng giá (có giá nhập)",
        link: "/config-system/price-list-update-history",
      },
      {
        label: "Lịch sử cập nhật bảng giá",
        link: "/config-system/price-list-update-history-no-import-price",
      },
      {
        label: "Báo cáo bảng giá",
        link: "/config-system/report-price-list",
      },
      {
        label: "Bảng giá sập sàn",
        link: "/config-system/rock-bottom-price-list",
      },
      {
        label: "Danh sách hàng hóa có biến động giá",
        link: "/config-system/item-fluctuation",
      },
      {
        label: "Kiểm tra tổng giá",
        link: "/config-system/check-summary-price",
      },
      {
        label: "Cấu hình ZNS",
        link: "/config-system/zns-configuration",
      },
    ],
  },
  {
    label: "Bán hàng",
    icon: IconShoppingCart,
    initiallyOpened: false,
    links: [
      {
        label: "Đơn bán lẻ",
        link: "/sell/retail-order",
      },
      {
        label: "Đơn bán buôn",
        link: "/sell/retail-order-wholesale",
      },
      {
        label: "In tem",
        link: "/sell/label-printing",
      },
      // {
      //   label: "Tạo đơn bán hàng",
      //   link: "/sell/sales-order",
      // },
      // {
      //   label: "Đơn đổi trả",
      //   link: "/sell/return-order",
      // },
      {
        label: "Đơn trả hàng",
        link: "/sell/return-order-v2",
      },
      {
        label: "Đơn đổi trả kỹ thuật",
        link: "/sell/return-order-technical",
      },
      {
        label: "Đơn trả hàng ( trả nguyên đơn)",
        link: "/sell/return-order-all",
      },
      {
        label: "Duyệt đơn trả hàng",
        link: "/sell/return-order-all-v2",
      },
      {
        label: "Danh sách đơn",
        link: "/sell/sales-order-list",
      },
      // {
      //   label: "Danh sách duyệt trả hàng",
      //   link: "/sell/sales-order-list-v2",
      // },
      {
        label: "Danh sách đơn (chỉ xem)",
        link: "/sell/sales-order-list-read-only",
      },
      {
        label: "Danh sách duyệt đơn",
        link: "/sell/approve-application-list",
      },
      {
        label: "Danh sách chờ duyệt giảm",
        link: "/sell/sales-order-list-origin-approva",
      },
      {
        label: "Danh sách đơn đã duyệt giảm",
        link: "/sell/sales-order-list-completed",
      },
      {
        label: "Danh sách duyệt đổi trả",
        link: "/sell/return-exchange-approval-list",
      },
      {
        label: "Danh sách đơn website gốc",
        link: "/sell/compare-sale-order-web",
      },
      {
        label: "Danh sách đơn website",
        link: "/sell/sales-order-list-web",
      },
      {
        label: "Danh sách đơn trả góp website",
        link: "/sell/sales-order-list-installment-web",
      },
      {
        label: "Danh sách đăng kí mua hàng website",
        link: "/sell/purchase-registration-list",
      },
      {
        label: "Danh sách đơn nợ khuyến mãi",
        link: "/sell/promotion-debt-list",
      },
      {
        label: "Đơn TMĐT",
        link: "/sell/retail-order-tmdt",
      },
      {
        label: "Danh sách đơn TMĐT",
        link: "/sell/sales-order-list-tmdt",
      },
      {
        label: "Danh sách đơn TMĐT (Chỉ xem)",
        link: "/sell/sales-order-list-tmdt-read-only",
      },
      {
        label: "Danh sách đơn hoàn TMDT",
        link: "/sell/sales-order-list-return-tmdt",
      },
      {
        label: "Danh sách hủy TMDT",
        link: "/sell/sales-order-list-cancel-tmdt",
      },

      {
        label: "Giao dịch ngân hàng",
        link: "/sell/banking-transactions",
      },
      // {
      //   label: "Danh sách đơn đổi trả",
      //   link: "/sell/sales-order-list-return",
      // },
      // { label: "Duyệt giảm", link: "/reduced-approval/discount-approval" },
      {
        label: "Sửa đơn hàng bán",
        link: "/sell/revise-order",
        hidden: true,
      },
      {
        label: "Sửa đơn hàng bán buôn",
        link: "/sell/revise-whole-order",
        hidden: true,
      },
      // {
      //   label: "Xuất bù khuyến mãi",
      //   link: "/sell/sales-order-promotions",
      // },
      // {
      //   label: "Phiếu thu tiền hàng",
      //   link: "/sell/payment-receipt",
      // },
      // {
      //   label: "Danh sách phiếu thu / chi",
      //   link: "/sell/list-receipts",
      // },
      // {
      //   label: "Phiếu thu nội bộ",
      //   link: "/sell/internal-receipt",
      // },
      {
        label: "Khách hàng",
        link: "/sell/customer",
        hidden: true,
      },
      {
        label: "Thông tin thanh toán",
        link: "/sell/screen-payment",
        hidden: true,
      },
      {
        label: "Viết hóa đơn VAT",
        link: "/sell/writeVAT",
      },
      {
        label: "Quản lý hóa đơn VAT",
        link: "/sell/vat-manager",
      },
      {
        label: "Điều chỉnh đơn hàng",
        link: "/sell/edit-order-list",
      },
      {
        label: "In tem sản phẩm",
        link: "/sell/print-product-label",
      },
    ],
  },
  {
    label: "Báo cáo đơn hàng",
    icon: IconReport,
    initiallyOpened: false,
    links: [
      {
        label: "Báo cáo doanh số tính lương hàng tháng",
        link: "/report/sales-revenue-report",
      },
      {
        label: "Báo cáo doanh số tính lương hàng tháng 2.0",
        link: "/report/sales-revenue-report-v2",
      },
      {
        label: "Báo cáo doanh số bán hàng",
        link: "/report/sales-list-order",
      },
      {
        label: "Báo cáo số lượng đơn và doanh số theo khách hàng",
        link: "/report/customer-order-report",
      },
      {
        label: "Báo cáo doanh số bán hàng Mobile app",
        link: "/report/sales-list-order-mobile-app",
      },
      {
        label: "Báo cáo bán hàng theo ngày",
        link: "/report/sales-list-by-day",
      },
      // {
      //   label: "Báo cáo lãi lỗ theo sản phẩm",
      //   link: "/report/sales-list-item",
      // },
      // {
      //   label: "Báo cáo lãi lỗ theo sản phẩm và chi nhánh",
      //   link: "/report/sales-list-item-branch",
      // },
      // {
      //   label: "Báo cáo bán hàng theo số điện thoại",
      //   link: "/report/sales-list-phone",
      // },
      // {
      //   label: "Báo cáo sản phẩm không có trong báo giá",
      //   link: "/report/sales-list-not-price",
      // },
      // {
      //   label: "Báo cáo theo thông tin khách hàng mua",
      //   link: "/report/sales-list-customer",
      // },
      {
        label: "Báo cáo bán hàng theo bộ phận",
        link: "/report/sales-list-department",
      },
      // {
      //   label: "Báo cáo bán hàng theo chi nhánh",
      //   link: "/report/sales-list-branch",
      // },
      // {
      //   label: "Báo cáo bán hàng theo phân kỳ",
      //   link: "/report/sales-period",
      // },
      // {
      //   label: "Báo cáo lãi lỗ theo hóa đơn",
      //   link: "/report/sales-profit-loss-invoice",
      // },
      // {
      //   label: "Thông tin đơn hàng",
      //   link: "/report/order-information",
      // },
      {
        label: "Báo cáo bán hàng theo mã vạch",
        link: "/report/sales-list-barcode",
      },
      {
        label: "Báo cáo bán hàng theo hóa đơn có mã dàn",
        link: "/report/sales-report-by-invoice-with-batch-codes",
      },
      {
        label: "Báo cáo doanh số theo sản phẩm",
        link: "/report/sales-report-by-product",
      },
      {
        label: "Báo cáo doanh số theo nhóm hàng",
        link: "/report/sales-report-by-cat-segment-5e",
      },
      {
        label: "Báo cáo doanh số theo tỉnh/thành phố phường/xã",
        link: "/report/sales-report-by-province-or-ward",
      },
      {
        label: "Báo cáo đơn hàng của KH không cung cấp địa chỉ",
        link: "/report/sales-report-no-address-customer",
      },
      {
        label: "Báo cáo giá trị tồn doanh thu",
        link: "/report/sales-report-inventory-value",
      },
      {
        label: "Báo cáo tuổi tồn",
        link: "/report/inventory-age-report",
      },
      {
        label: "Báo cáo tuổi tồn theo chi nhánh",
        link: "/report/inventory-age-report-branch",
      },
      {
        label: "Báo cáo duyệt giảm giá",
        link: "/report/discount-approval-report",
      },
      {
        label: "Báo cáo tuổi tồn theo hàng hóa",
        link: "/report/inventory-age-report-item",
      },
      {
        label: "Báo cáo tuổi tồn theo nhóm hàng",
        link: "/report/inventory-age-report-item-group",
      },
      {
        label: "Báo cáo CTKM tự nhập",
        link: "/report/manual-promotion-program-report",
      },
      {
        label: "Báo cáo bán hàng theo chi nhánh/bộ phận",
        link: "/report/sales-by-branch",
      },
      {
        label: "Báo cáo bán hàng theo nhân viên",
        link: "/report/sales-by-staff",
      },
      {
        label: "Đơn mua hàng không có thông tin tiền",
        link: "/report/purchase-order-report-excluding-price-information",
      },
      {
        label: "Báo cáo sản phẩm có serial và no serial",
        link: "/report/get-product-by-serial",
      },
      {
        label: "Báo cáo thời hạn phiếu THEK-phiếu PHG",
        link: "/report/get-time-THEK-PHG",
      },
      {
        label: "Báo cáo đếm số lần điều chuyển chi nhánh cho từng serial",
        link: "/report/get-count-brand-serial",
      },
      {
        label: "Lịch sử sử dụng voucher",
        link: "/report/voucher-usage-history",
      },
      {
        label: "Báo cáo voucher sử dụng theo chi nhánh",
        link: "/report/report-use-voucher",
      },
    ],
  },
  {
    label: "Kho hàng",
    icon: IconBuildingWarehouse,
    initiallyOpened: false,
    links: [
      {
        label: "Danh sách đơn mua hàng",
        link: "/warehouse-config/purchase-order",
        hidden: true,
      },
      {
        label: "Đơn mua hàng",
        link: "/warehouse-config/import-purchases",
        hidden: true,
      },
      {
        label: "Theo dõi nhập xuất",
        link: "/warehouse-config/inoutwarehouse-management",
      },
      {
        label: "Kiểm kê serial POS",
        link: "/warehouse-config/serial-stocktake",
      },
      {
        label: "Báo cáo kiểm kê theo serial",
        link: "/warehouse-config/serial-stocktake-difference-report",
      },
      {
        label: "Báo cáo kiểm kê theo mã vật tư",
        link: "/warehouse-config/serial-stocktake-summary-report",
      },
      // {
      //   label: "Kiểm kê kho",
      //   link: "/warehouse-config/warehouse-management",
      // },
      {
        label: "Yêu cầu điều chuyển",
        link: "/warehouse-config/request-transfer",
      },
      {
        label: "Yêu cầu điều chuyển (nội bộ)",
        link: "/warehouse-config/request-transfer-internal",
      },
      // {
      //   label: "Xuất kho điều chỉnh",
      //   link: "warehouse-config/export-adjustment",
      // },
      // {
      //   label: "Lập yêu cầu điều chuyển nội bộ",
      //   link: "warehouse-config/request-internal-transfer",
      // },
      // {
      //   label: "Quản lý sổ kho",
      //   link: "warehouse-config/warehouse-transaction",
      // },
      {
        label: "Phiếu cần xuất kho",
        link: "/warehouse-config/request-inventory-transaction",
      },
      {
        label: "Phiếu cần nhập kho",
        link: "/warehouse-config/request-inward-transaction",
      },
      // {
      //   label: "Danh sách đơn cần nhập",
      //   link: "/warehouse-config/request-inventory-transaction?Type=1",
      // },
      // {
      //   label: "Danh sách phiếu xuất/nhập hàng NCC",
      //   link: "/warehouse-config/supplier-slip",
      // },
      {
        label: "Phiếu cần xuất từ Asia",
        link: "/warehouse-config/export-supplier-slip",
      },
      {
        label: "Phiếu cần nhập từ Asia",
        link: "/warehouse-config/import-supplier-slip",
      },
      {
        label: "Danh sách kho serial",
        link: "/warehouse-config/list-serial",
        hidden: true,
      },
      // {
      //   label: "Danh sách phiếu nhập thành phẩm",
      //   link: "/warehouse-config/create-finished-product-receipt",
      //   hidden: true,
      // },
      {
        label: "Quản lý phiếu xuất kho",
        link: "/warehouse-config/warehouse-out-ward",
      },

      {
        label: "Quản lý phiếu nhập kho",
        link: "/warehouse-config/warehouse-in-ward",
      },
      // {
      //   label: "Danh mục vị trí kho",
      //   link: "/warehouse-config/warehouse-location-list",
      // },
      // {
      //   label: "Lập lệnh sản xuất",
      //   link: "/warehouse-config/wip",
      // },
      {
        label: "Danh sách chi tiết đơn mua hàng",
        link: "/warehouse-config/purchase-order-detail",
        hidden: true,
      },
      {
        label: "Bảng kê phiếu nhập/phiếu xuất",
        link: "/warehouse-config/inventoryTransfer",
      },
      {
        label: "Báo cáo yêu cầu điều chuyển",
        link: "/warehouse-config/report-request-transfer",
      },
      {
        label: "Báo cáo tồn kho tổng quát",
        link: "/warehouse-config/general-inventory",
      },
      {
        label: "Báo cáo tồn kho số lượng",
        link: "/warehouse-config/inventoryReport",
      },
      {
        label: "Báo cáo tồn kho số lượng hàng bán",
        link: "/warehouse-config/inventoryReportHb",
      },
      {
        label: "Chu kỳ kiểm kê kho",
        link: "/warehouse-config/inventory-cycle-count",
        hidden: true,
      },
      {
        label: "Tạo yêu cầu điều chuyển kho",
        link: "/warehouse-config/create-request-transfer",
        hidden: true,
      },
      {
        label: "Chỉnh sửa yêu cầu điều chuyển kho",
        link: "/warehouse-config/edit-request-transfer",
        hidden: true,
      },
      {
        label: "Chi tiết yêu cầu điều chuyển kho",
        link: "/warehouse-config/detail-request-transfer",
        hidden: true,
      },
      {
        label: "Quản lý sổ kho",
        link: "/warehouse-config/warehouse-transaction",
        hidden: true,
      },
      {
        label: "Tạo phiếu xuất kho",
        link: "/warehouse-config/create-warehouse-out-ward",
        hidden: true,
      },
      {
        label: "Chỉnh sửa phiếu xuất kho",
        link: "/warehouse-config/edit-warehouse-out-ward",
        hidden: true,
      },
      {
        label: "Xem chi tiết phiếu xuất kho",
        link: "/warehouse-config/detail-warehouse-out-ward",
        hidden: true,
      },
      {
        label: "Lập phiếu nhập kho",
        link: "/warehouse-config/create-warehouse-in-ward",
        hidden: true,
      },
      {
        label: "Chỉnh sửa phiếu nhập kho",
        link: "/warehouse-config/edit-warehouse-in-ward",
        hidden: true,
      },

      {
        label: "Tạo phiếu nhập hàng mua",
        link: "/warehouse-config/create-warehouse-purchase-in-ward",
        hidden: true,
      },
      {
        label: "Phiếu nhập hàng nhà cung cấp",
        link: "/warehouse-config/supplier-request-form",
        hidden: true,
      },

      {
        label: "Xuất kho hủy",
        link: "/warehouse-config/export-adjustment",
        hidden: true,
      },
      // {
      //   label: "Danh sách phiếu nhập thành phẩm",
      //   link: "/warehouse-config/finished-goods-receipt-list",
      // },
      {
        label: "Danh mục trạng thái mã vạch ",
        link: "/warehouse-config/barcode-status",
        hidden: true,
      },
      {
        label: "Báo cáo lịch sử mã vạch",
        link: "/warehouse-config/barcode-history",
      },
      // {
      //   label: "Danh sách sản phẩm",
      //   link: "/warehouse-config/category-combination",
      // },
      {
        label: "Báo cáo tồn kho theo mã vạch",
        link: "/warehouse-config/InventoryReportByBarcode",
      },
      {
        label: "Báo cáo tồn kho theo mã vạch (đơn giá nhập)",
        link: "/warehouse-config/InventoryReportByBarcodeV2",
      },
      {
        label: "Báo cáo tồn kho theo mã vạch(Chủng,loại)",
        link: "/warehouse-config/report-inventory-by-serial",
      },
      {
        label: "Báo cáo tồn kho theo vị trí",
        link: "/warehouse-config/inventoryReportList",
      },
      {
        label: "Báo cáo so sánh tồn kho serial và tồn kho số lượng",
        link: "/warehouse-config/report-on-comparing-serial-inventory-and-quantity-inventory",
      },
      {
        label: "Báo cáo tình trạng serial",
        link: "/warehouse-config/report-serial-status",
      },
      {
        label: "Báo cáo phụ tùng thay thế",
        link: "/warehouse-config/spare-part-report",
      },
      {
        label: "Báo cáo tồn kho số lượng toàn công ty",
        link: "/warehouse-config/inventoryReportCompany",
      },
      {
        label: "Báo cáo liệt kê chứng từ giữ hàng",
        link: "/warehouse-config/order-documents",
      },
      {
        label: "Báo cáo nhập-xuất-tồn",
        link: "/warehouse-config/change-information",
      },
      // {
      //   label: "Báo cáo nhập-xuất-tồn theo mã vạch",
      //   link: "/warehouse-config/inventory-balance-serial-report",
      // },
      {
        label: "Báo cáo nhập-xuất-tồn, tuổi tồn theo mã vạch",
        link: "/warehouse-config/report-in-out-balance",
      },
      {
        label: "Báo cáo lưu kho",
        link: "/warehouse-config/storage-report",
      },
      {
        label: "Báo cáo lưu kho bán hàng",
        link: "/warehouse-config/storage-report-order",
      },
      {
        label: "Báo cáo điều chuyển",
        link: "/warehouse-config/check-req-tranfer-request",
      },
      {
        label: "Báo cáo danh sách mã vạch",
        link: "/warehouse-config/inventorySerial",
      },
      {
        label: "Báo cáo tồn kho theo chi nhánh",
        link: "/warehouse-config/iventory-serial-item-by-branch",
      },
      {
        label: "Báo cáo cân hàng",
        link: "/warehouse-config/weighing-report",
      },
      {
        label: "Serial con",
        link: "/warehouse-config/check-req-tranfer-requestv",
      },
      {
        label: "Cập nhật giá sản phẩm đổi mã",
        link: "/warehouse-config/list-edit-price",
      },
      {
        label: "Điều chỉnh kho",
        link: "/warehouse-config/list-edit",
      },
      {
        label: "Báo cáo tồn kho theo mã vạch, theo người nhập",
        link: "/warehouse-config/get-inventory-by-serial",
      },
      {
        label: "Báo cáo tổng tồn kho theo chi nhánh",
        link: "/warehouse-config/get-sum-list-serial",
      },
      {
        label: "Báo cáo tổng tồn kho theo chi nhánh(quá khứ)",
        link: "/warehouse-config/get-sum-list-serial-qk",
      },
      {
        label: "Báo cáo số lần xuất bán và nhập lại cho từng serial",
        link: "/warehouse-config/get-count-export-import-serial",
      },
      {
        label: "Báo cáo tỷ trọng hàng tồn kho theo thời gian",
        link: "/warehouse-config/get-weight-serial",
      },
      {
        label: "Báo cáo vi phạm FIFO",
        link: "/warehouse-config/get-warning-fifo",
      },
      {
        label: "Báo cáo mã vạch có người đề nghị",
        link: "/warehouse-config/thong-tin-yeu-cau-nhap-mua",
      },
      {
        label: "Báo cáo phiếu cần xuất kho quá hạn",
        link: "/warehouse-config/overdue-pending-outbound-report",
      },
    ],
  },
  {
    label: "Kiểm kê",
    icon: IconClipboardCheck,
    initiallyOpened: false,
    links: [{ label: "Danh sách serial", link: "/stocktaking/list-serial" }],
  },
  {
    label: "Lệnh sản xuất",
    icon: IconBuildingFactory2,
    initiallyOpened: false,
    links: [
      {
        label: "Lập lệnh sản xuất",
        link: "warehouse-config/wip",
      },
      {
        label: "Rã bộ",
        link: "/warehouse-config/product-separation",
      },
      {
        label: "Báo cáo lắp ráp máy",
        link: "/warehouse-config/wip-report",
      },
      {
        label: "Báo cáo tồn kho lắp máy",
        link: "/warehouse-config/machine-installation-inventory-report",
      },
    ],
  },
  {
    label: "Đề xuất",
    icon: IconBrowser,
    initiallyOpened: false,
    links: [
      {
        label: "Chi tiết đề xuất",
        link: "/proposal/proposal-detail",
        hidden: true,
      },
      {
        label: "Danh sách đề xuất",
        link: "/proposal/approve-proposal",
      },
      {
        label: "Sửa đề xuất",
        link: "/proposal/edit-proposal",
        hidden: true,
      },
      {
        label: "Tạo đề xuất",
        link: "/proposal/create-proposal",
        hidden: true,
      },
    ],
  },
  {
    label: "Phiếu thu / chi",
    icon: IconReceipt,
    initiallyOpened: false,
    links: [
      {
        label: "Danh sách phiếu thu / chi",
        link: "/bill/list-receipts",
      },
      {
        label: "Danh sách báo có toàn công ty",
        link: "/bill/newspaper-list-available",
      },
      {
        label: "Phiếu điều chỉnh",
        link: "/bill/adjustment-slip",
      },
      {
        label: "Danh sách phiếu bàn giao",
        link: "/bill/handover-slip-list",
      },
      {
        label: "Lập phiếu bàn giao",
        link: "/bill/handover-slip",
      },
      {
        label: "Danh sách phiếu chi",
        link: "/bill/list-payment-slip",
        hidden: true,
      },
      {
        label: "Chi tiết phiếu bàn giao",
        link: "/bill/handover-slip-detail",
        hidden: true,
      },
      {
        label: "Lập phiếu thu đơn hàng",
        link: "/bill/payment-receipt",
      },
      {
        label: "Lập phiếu báo có đơn hàng",
        link: "/bill/order-confirmation",
      },
      {
        label: "Lập phiếu thu khác",
        link: "/bill/internal-receipt",
      },
      {
        label: "Lập phiếu báo có khác",
        link: "/bill/credit-advice",
      },
      // {
      //   label: "Lập phiếu chi",
      //   link: "/bill/payment-slip",
      // },
      {
        label: "Xem chi tiết phiếu",
        link: "/bill/detail-payment-receipt",
        hidden: true,
      },
      // {
      //   label: "Lập phiếu báo nợ",
      //   link: "/bill/debt-note",
      // },
      {
        label: "Lập phiếu chi ",
        link: "/bill/payment-slip-branches",
      },
      {
        label: "Lập phiếu báo nợ ",
        link: "/bill/debt-note-branches",
      },

      {
        label: "Tỉ giá vàng",
        link: "/bill/exchange-rate",
        hidden: true,
      },
      {
        label: "Tạo mới phiếu điều chỉnh",
        link: "/bill/add-adjustment-slip",
        hidden: true,
      },
      {
        label: "Báo cáo sổ quỹ",
        link: "/report/payment-receipt",
      },
    ],
  },
  {
    label: "Giao vận",
    icon: IconTransfer,
    initiallyOpened: false,
    links: [
      {
        label: "Đơn giao hàng",
        link: "/delivery-config/delivery",
      },
      {
        label: "Thực hiện vận đơn",
        link: "/delivery-config/delivery-dispatch",
      },
      {
        label: "Báo cáo điều chuyển đơn vị giao hàng",
        link: "/delivery-config/ghtk-ahamove-delivery-report",
      },
      {
        label: "Báo cáo tính lương giao vận",
        link: "/delivery-config/Delivery-performance",
      },
      {
        label: "Báo cáo tính lương kỹ thuật giao hàng",
        link: "/delivery-config/delivery-pay-kt",
      },
      {
        label: "Báo cáo tính lương dự án",
        link: "/delivery-config/Delivery-project",
      },
      {
        label: "Báo cáo tính lương giao vận thi công",
        link: "/delivery-config/Delivery-performance-kttc",
      },
      {
        label: "Báo cáo tổng điểm dự án",
        link: "/delivery-config/project-logistics-total-score-report",
      },
      {
        label: "Báo cáo tổng điểm kỹ thuật thi công",
        link: "/delivery-config/construction-technical-score-summary-report",
      },
      {
        label: "Tạo mới đơn giao hàng",
        link: "/delivery-config/delivery-create",
        hidden: true,
      },
      {
        label: "Báo cáo tiền đơn hàng",
        link: "/delivery-config/Delivery-monney",
      },
      {
        label: "Báo cáo tổng tiền đơn hàng",
        link: "/delivery-config/Delivery-all-monney",
      },
      {
        label: "Báo cáo các đơn hàng trùng mã KH trong cùng một ngày",
        link: "/delivery-config/ReportOnOrders",
      },
      {
        label: "Bảng kê đơn hàng giao hơn 1 vận đơn",
        link: "/delivery-config/DeliveryInOneDay",
      },
      {
        label: "Báo cáo GHTK",
        link: "/delivery-config/GHTK",
      },
      {
        label: "Báo cáo Ahamove",
        link: "/delivery-config/Ahamove",
      },
      {
        label: "Báo cáo COD",
        link: "/delivery-config/COD",
      },
      {
        label: "Báo cáo giao vận chưa đồng bộ",
        link: "/delivery-config/not-sync",
      },
    ],
  },

  {
    label: "Kỹ thuật kiểm tra",
    icon: IconSettingsQuestion,
    initiallyOpened: false,
    links: [
      {
        label: "Kỹ thuật kiểm tra",
        link: "/testing/testing-technique",
      },
      {
        label: "Tạo mới kỹ thuật kiểm tra",
        link: "/testing/create-testing-technique",
        hidden: true,
      },
      {
        label: "Chi tiết kỹ thuật kiểm tra",
        link: "/testing/detail-testing-technique",
        hidden: true,
      },
      {
        label: "Phân công kỹ thuật kiểm tra",
        link: "/testing/assign-testing-technique",
        hidden: true,
      },
      {
        label: "Báo cáo tính lương KTKT",
        link: "/testing/payroll-report",
      },
      {
        label: "Báo cáo tổng điểm nhân viên KTBH",
        link: "/testing/employee-technical-points",
      },
      // {
      //   label: "Tiếp nhận kiểm tra",
      //   link: "/testing/reception-testing-technique",
      // },
    ],
  },

  // {
  //   label: "Duyệt giảm",
  //   icon: IconDiscount,
  //   initiallyOpened: false,
  //   links: [
  //     { label: "Duyệt giảm", link: "/reduced-approval/discount-approval" },
  //   ],
  // },

  {
    label: "Dịch vụ sửa chữa",
    icon: IconSettings,
    initiallyOpened: false,
    links: [
      {
        label: "Tiếp nhận dịch vụ",
        link: "/service-repair/receive-ticket-list",
      },
      {
        label: "Bảng kê hàng dịch vụ",
        link: "/service-repair/defective-goods-list",
      },
      {
        label: "Kỹ thuật kiểm tra",
        link: "/service-repair/testing-technique",
      },
      {
        // Hiện thêm ở module DVSC nhưng dùng ĐÚNG đường dẫn của màn bảo hành:
        // không thêm route, không cần cấp thêm quyền menu
        label: "Báo cáo lịch sử mã vạch V2",
        link: "/warranty/barcode-history-v2",
      },
    ],
  },
  {
    label: "Bảo hành",
    icon: IconTool,
    initiallyOpened: false,
    links: [
      {
        label: "Báo cáo lịch sử mã vạch V2",
        link: "/warranty/barcode-history-v2",
      },
      {
        label: "Danh sách thông tin yêu cầu bảo hành",
        link: "/warranty/warranty-claim-information",
      },
      {
        label: "Lập phiếu tiếp nhận yêu cầu",
        link: "/warranty/receive-warranty",
      },
      {
        label: "Xử lý yêu cầu",
        link: "/warranty/request-processing",
      },
      {
        label: "Theo dõi hãng xử lý tại nhà",
        link: "/warranty/warranty-company",
      },
      {
        label: "Thực hiện xử lý tại nhà",
        link: "/warranty/perform-home-warranty",
      },
      {
        label: "Phiếu tiếp nhận hàng lỗi",
        link: "/warranty/receive-ticket-list",
      },
      {
        label: "Bảng kê hàng lỗi (Hàng khách)",
        link: "/warranty/defective-goods-list-v2",
      },
      {
        label: "Bảng kê hàng lỗi (Hàng kho)",
        link: "/warranty/defective-goods-list",
      },
      {
        label: "Phiếu nhập kho hàng lỗi",
        link: "/warranty/warranty-receive-item",
        hidden: true,
      },
      // {
      //   label: "Xuất bảo hành NCC",
      //   link: "/warranty/supplier-warranty-export",
      // },
      // {
      //   label: "Xuất trả khách",
      //   link: "/warranty/return-customers",
      // },
      {
        label: "Thông tin phân công",
        link: "/warranty/warranty-information",
      },
      {
        label: "Danh sách gia hạn bảo hành",
        link: "/warranty/warranty-list",
      },
      {
        label: "Phiếu xuất nhập hàng mượn",
        link: "/warranty/list-borrowed-goods",
      },
      {
        label: "Bảng kê hàng mượn",
        link: "/warranty/list-of-borrowed-items",
      },
      {
        label: "Thông tin khách hàng hẹn gặp",
        link: "/warranty/customer-warranty",
      },
      {
        label: "Cấu hình nhóm khách hàng",
        link: "/warranty/customer-group",
      },
      {
        label: "Dữ liệu chuyển đổi bảo hành",
        link: "/warranty/warranty-conversion-data",
      },
      {
        label: "Lịch sử mua hàng",
        link: "/warranty/purchase-history",
      },
      {
        label: "Lịch sử sản phẩm bảo hành",
        link: "/warranty/product-warranty-history",
      },
      // {
      //   label: "Báo cáo thực hiện giao hàng",
      //   link: "/warranty/report-delivery-performance",
      // },
      {
        label: "Báo cáo thực hiện xử lý yêu cầu",
        link: "/warranty/request-form-report",
      },
      {
        label: "Báo cáo serial xuất bán hoặc nhập lại",
        link: "/warranty/export-or-re-export",
      },
      {
        label: "Báo cáo xuất gửi nhà cung cấp",
        link: "/warranty/report-export-supplier",
      },
      {
        label: "Thông tin bảo hành",
        link: "/warranty/warrantyInformation",
      },
      {
        label: "QR tiếp nhận dịch vụ bảo hành",
        link: "/warranty/qr-service-receipt-warranty",
      },
      {
        label: "Biên bản kiểm kê hàng bảo hành",
        link: "/warranty/inventory-record",
      },
      {
        label: "Báo cáo tỷ lệ hàng lỗi bảo hành",
        link: "/warranty/report-defective-goods-rate",
      },
      {
        label: "Báo cáo tồn - nhập - trả bảo hành",
        link: "/warranty/report-inventory-import-warranty-return",
      },
      {
        label: "Báo cáo theo dõi KTBH",
        link: "/warranty/tracking-report-warranty",
      },
      {
        label: "Báo cáo tháng KTBH",
        link: "/warranty/report-for-month",
      },
      {
        label: "Báo cáo phân tích tiếp nhận và xử lý bảo hành",
        link: "/warranty/warranty-reception-processing-report",
      },
      {
        label: "Điều chỉnh nhập kho BH NCC",
        link: "/warranty/inventory-transfer-warranty",
      },
      {
        label: "Lịch sử SMS bảo hành",
        link: "/warranty/history-sms-bh",
      },
    ],
  },
  {
    label: "Phân quyền",
    icon: IconBrandAuth0,
    initiallyOpened: false,
    links: [
      {
        label: "Đồng bộ",
        link: "/authozire/alignment",
      },
      {
        label: "Nhóm menu",
        link: "/authozire/menu-group",
      },
      {
        label: "Danh mục chức năng",
        link: "/authozire/roles",
      },
      {
        label: "Nhóm người dùng",
        link: "/authozire/groups",
      },
      {
        label: "Phân quyền chức năng - menu",
        link: "/authozire/permissions",
      },
      {
        label: "Nhóm kho và vị trí",
        link: "/authozire/groups-brand-inventory",
      },
      {
        label: "Tài khoản người dùng",
        link: "/authozire/users",
      },
      {
        label: "Phân quyền xin giảm",
        link: "/authozire/decentralize-reduction",
      },
      {
        label: "Phân quyền duyệt KT đổi trả",
        link: "/authozire/return-technical-exchange",
      },
      {
        label: "Phân quyền báo cáo",
        link: "/authozire/report-category",
      },
      {
        label: "Danh sách quyền chuyển kho",
        link: "/authozire/request-manager-transfer",
      },
      {
        label: "Danh mục App",
        link: "/authozire/app",
      },
      {
        label: "Lịch sử và phê duyệt",
        link: "/authozire/history-and-approve",
      },
      // {
      //   label: "Nhật ký hệ thống",
      //   link: "/authozire/logging",
      // },
      // {
      //   label: "Cấu hình hệ thống",
      //   link: "/authozire/topic-error",
      // },
      // {
      //   label: "Danh sách và phê duyệt đăng nhập",
      //   link: "/authozire/topic-error",
      // },
      // {
      //   label: "Danh sách online",
      //   link: "/authozire/online",
      // },
      // {
      //   label: "Logging Req",
      //   link: "/authozire/logging-req",
      // },
      {
        label: "Logging Req v2",
        link: "/authozire/logging-req-v2",
      },
      {
        label: "Topic error",
        link: "/authozire/topic-error",
      },
      {
        label: "Xóa cache hệ thống",
        link: "/authozire/delete-cache",
      },
    ],
  },
  // {
  //   label: "Tổ chức",
  //   icon: IconUsersGroup,
  //   initiallyOpened: false,
  //   links: [
  //     {
  //       label: "Phòng ban",
  //       link: "/organization/department",
  //     },
  //     {
  //       label: "Chức vụ",
  //       link: "/organization/position",
  //     },
  //     {
  //       label: "Nhân viên",
  //       link: "/organization/staff",
  //     },
  //   ],
  // },
  {
    label: "Bảng kê",
    icon: IconReport,
    initiallyOpened: false,
    links: [
      {
        label: "Bảng kê chứng từ",
        link: "/Statement/vall-transaction",
      },
    ],
  },
  {
    label: "Báo cáo",
    icon: IconReport,
    initiallyOpened: false,
    links: [
      {
        label: "Mẫu báo cáo",
        link: "/report/example",
      },
      {
        label: "Thêm template cho mẫu báo cáo",
        link: "/report/add-or-update-file",
      },
      {
        label: "Tồn kho theo serial",
        link: "/report/inventory-serial-onhand",
      },
      {
        label: "Bảng kê bán hàng",
        link: "/report/sales-list",
      },
    ],
  },
  {
    label: "Kho dữ liệu",
    icon: IconDatabase,
    initiallyOpened: false,
    links: [
      {
        label: "Kho dữ liệu",
        link: "/warehouse-data/list-warehouse-data",
      },
    ],
  },
  {
    label: "Đối chiếu dữ liệu",
    icon: IconZoomReplace,
    initiallyOpened: false,
    links: [
      {
        label: "Đối chiếu dữ liệu POS/ASIA",
        link: "/compare/compare-data-asia-pos",
      },
      {
        label: "Đối chiếu kho POS/ASIA",
        link: "/compare/compare-inventory",
      },
      {
        label: "Đối chiếu vật tư POS/ASIA",
        link: "/compare/compare-item-pos-asia",
      },
      {
        label: "Đối chiếu sản phẩm POS/Website",
        link: "/compare/compare-item-pos-web",
      },
      {
        label: "Đối chiếu bảng kê POS/ASIA",
        link: "/compare/compare-defective-pos-asia",
      },
    ],
  },
  {
    label: "Xuất dữ liệu",
    icon: IconFileExport,
    initiallyOpened: false,
    links: [
      {
        label: "Xuất dữ liệu",
        link: "/export-data/export-excel-page",
      },
    ],
  },
];
